import { ButtonProps, Grid, Button, Typography } from '@material-ui/core'
import { styled as muiStyled, Theme } from '@material-ui/core/styles'
import ContactButton from 'components/Button/ContactButton'
import Router from 'next/router'
import Analytics from 'utils/analytics'
import { useTranslation } from 'i18n'

const TopScreen = () => {
  const { t: trans } = useTranslation('root')
  const t = key => trans('TopScreen.' + key)

  const onClickSignupAsArtist = () => {
    Analytics.track('click:signupOnTop')
    Router.push('/artist/signup')
  }

  return (
    <ContainerGrid container direction="row-reverse">
      <DescriptionGrid item xs={12} md={7}>
        {' '}
        <Title variant="h4">{t('title')}</Title>
        <Text>{t('subscription')}</Text>
      </DescriptionGrid>
      <ButtonsGrid item xs={12} md={5}>
        <StyledButton onClick={onClickSignupAsArtist}>
          {t('signupAsArtist')}
        </StyledButton>
        <ContactButton />
      </ButtonsGrid>
    </ContainerGrid>
  )
}

export default TopScreen

const DescriptionGrid = muiStyled(Grid)({
  lineHeight: 10,
  textAlign: 'center',
  margin: 'auto',
})

const ButtonsGrid = muiStyled(Grid)(({ theme: { breakpoints: b } }) => ({
  textAlign: 'center',
  padding: '30px 0',
  [b.up('xs')]: {
    margin: 'auto',
  },
}))

const StyledButton = muiStyled(Button)<Theme, ButtonProps>(
  ({ theme: { breakpoints: b }, variant }) => ({
    color: variant == 'contained' ? '#5F3CA1' : 'white',
    border: 'white solid 2px',
    borderRadius: 20,
    fontWeight: 600,
    width: 250,
    margin: '20px',
    fontSize: 16,
    [b.down('xs')]: {
      fontSize: 12,
    },
  })
)

const ContainerGrid = muiStyled(Grid)(({ theme: { breakpoints: b } }) => ({
  maxWidth: 1180,
  padding: '65px 50px 0 50px',
  margin: '0 auto',
  height: 800,
  [b.down('sm')]: {
    padding: '65px 20px 0 20px',
    height: 500,
  },
}))

const Title = muiStyled(Typography)(({ theme: { breakpoints: b } }) => ({
  color: 'white',
  padding: '0 0 20px 0',
  fontWeight: 600,
  whiteSpace: 'pre-wrap',
  [b.down('xs')]: {
    fontSize: 26,
  },
}))

const Text = muiStyled(Typography)(({ theme: { breakpoints: b } }) => ({
  color: 'white',
  fontSize: 16,
  padding: '0 40px',
  whiteSpace: 'pre-wrap',
  [b.down('xs')]: {
    fontSize: 14,
  },
}))
